// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F2Gl3"};